// extracted by mini-css-extract-plugin
export var actions = "_4k-0";
export var actionsContainer = "_4k-7";
export var border = "_4k-1";
export var childFullHeight = "_4k-e";
export var collapse = "_4k-2";
export var content = "_4k-9";
export var contentChild = "_4k-d";
export var fullscreen = "_4k-b";
export var hasLeftRadius = "_4k-j";
export var headerContainer = "_4k-3";
export var headerRow = "_4k-5";
export var hidePadding = "_4k-a";
export var navCollapsedGap = "_4k-k";
export var noScrollX = "_4k-l";
export var noScrollY = "_4k-m";
export var noTopPadding = "_4k-h";
export var optOutTopPadding = "_4k-c";
export var pageMain = "_4k-i";
export var pageOuter = "_4k-f";
export var pagePadding = "_4k-8";
export var profile = "_4k-n";
export var profileContainer = "_4k-o";
export var profileImage = "_4k-p";
export var profileMain = "_4k-q";
export var profileSubtitle = "_4k-s";
export var profileTitle = "_4k-r";
export var showLeftPadding = "_4k-g";
export var tabsPortalSlot = "_4k-6";
export var tabsWrapper = "_4k-4";
export var title = "_4k-t";